import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { persistor, store } from "./slices/store";
import ClientProvider from 'providers/clientProvider';
import { PersistGate } from 'redux-persist/integration/react';
import './lib/utils/i18n';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <Provider store={store}>
    <React.Fragment>
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <ClientProvider>
          <PersistGate loading={null} persistor={persistor}>
            <App />
          </PersistGate>
        </ClientProvider>
      </BrowserRouter>
    </React.Fragment>
  </Provider>
);
reportWebVitals();